import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { ApiWrapper, PollingApi, IFetchResponse, PushApi, IParsable, ARequestVM, NoApiWrapper, FetchApi } from "./Api";
import { SingleEntityTextFilter } from "./Filter";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export class ChartConfig {
    vAxisMin = 0;
    vAxisMax = 1;
    strictMinMax = true;
}


class AmChartWrapper implements IFetchResponse {

    public requestVM: AmChartReqeuestVM;

    protected _am4ChartElement: am4core.Optional<string | HTMLElement>;
    private apiWrapper: ApiWrapper;
    protected indicatorLabel: am4core.Label | undefined; // see https://codepen.io/team/amcharts/pen/zyvQjd?editors=0010   
    protected config: ChartConfig | undefined;
    

    constructor(divUnkown: unknown) {
        am4core.options.commercialLicense = true;

        this._am4ChartElement = divUnkown as am4core.Optional<string | HTMLElement>;
        this.apiWrapper = new NoApiWrapper("template");
        this.requestVM = new AmChartReqeuestVM();
    }

    fetchData() {
        this.apiWrapper.fetchData(this, this.requestVM);
    }

    setFetchApi(path: string) {
        let fetchApi = new FetchApi(path);
        this.apiWrapper = fetchApi;
    }

    setPollingApi(path: string, timeoutInMilli: number) {
        let pollingApi = new PollingApi(path, timeoutInMilli);
        this.apiWrapper = pollingApi;

    }


    setPushApi(path: string) {
        let pushApi = new PushApi(path);
        this.apiWrapper = pushApi;
    }

    success(data: object): void {
        //template, must be overriden 
    }
    error(error: object): void {
        //template, must be overriden 
    }


    showChart(isData: boolean) {
        if (this.indicatorLabel === undefined) return;

        if (isData!==true) {
            this.indicatorLabel.text = "No data...";
            this.indicatorLabel.align = "center";
            this.indicatorLabel.valign = "middle";
            this.indicatorLabel.fontSize = 15;
            this.indicatorLabel.show();
        } else {
            this.indicatorLabel.hide();
        }

    }

    setConfig(config: ChartConfig) {
        this.config = config;
    }


}

export class DataSet {

    public data: object[];

    constructor() {
        this.data = new Array();
    }

    addData(keyName: string, keyVal: string, valueName: string, valueVal: string) {
        let test = { [keyName]: keyVal, [valueName]: valueVal };
        this.data.push(test);
    }
}


class PieChartReportVM implements IParsable {
    public data: DataSet;
    public category: string;
    public value: string;

    constructor() {
        this.data = new DataSet();
        this.category = "";
        this.value = "";
    }

    parseJson(jsonToParse: any): void {
        try {
            this.data.data = jsonToParse["data"];
            this.value = jsonToParse["value"];
            this.category = jsonToParse["category"];
        }
        catch (Error) {
            this.data = new DataSet();
        }
    }

}

class CategoryChartReportVM implements IParsable {
    public categoryAxes: string[];
    public series: [string, string][];
    public data: DataSet;
    public IsHorizontalChart: boolean;

    constructor() {
        this.series = new Array();
        this.categoryAxes = new Array();
        this.data = new DataSet();
        this.IsHorizontalChart = false;
    }
    //try to parse json response
    parseJson(jsonToParse: any) {
        try {
            //todo do actual parsing
            this.categoryAxes = jsonToParse["categoryAxes"];
            this.series = jsonToParse["series"];
            this.data.data = jsonToParse["data"];
            this.IsHorizontalChart = jsonToParse["isHorizontal"];
        }
        catch (Error) {
            //error in parsing, display no data;
            this.series = new Array();
            this.categoryAxes = new Array();
            this.data = new DataSet();
            //TODO: may display an error message?
        }
    }
}

export class XYChartReportVM implements IParsable {
    public category: string;
    public value: string;
    public data: DataSet;
    public IsHorizontalChart: boolean;

    constructor() {
        this.category = "CAT";
        this.value = "val";
        this.data = new DataSet();
        this.IsHorizontalChart = false;
    }
    //try to parse json response
    parseJson(jsonToParse: any) {
        try {
            //todo do actual parsing
            this.category = jsonToParse["category"];
            this.value = jsonToParse["value"];
            this.data.data = jsonToParse["data"];
            this.IsHorizontalChart = jsonToParse["isHorizontal"];
        }
        catch (Error) {
            //error in parsing, display no data;
            this.category = "error";
            this.value = "error";
            this.data = new DataSet();
            //TODO: may display an error message?
        }
    }
}


export class AmChartReqeuestVM extends ARequestVM {
    constructor() {
        super();
    }


}

class PieChartRequestVM extends AmChartReqeuestVM {

}

export class CategoryChartRequestVM extends AmChartReqeuestVM {

    constructor() {
        super();

    }

    addSingleEntityFilter(searchString: string) {
        let filter = new SingleEntityTextFilter(searchString);
        this.addFilter(filter)
    }

}

export class XYChartRequestVM extends AmChartReqeuestVM {

    constructor() {
        super();

    }
}


export class CategoryChart extends AmChartWrapper {

    public amChart: am4charts.XYChart;
    private isInitialized: boolean = false;
    //private indicatorLabel: am4core.Label; // see https://codepen.io/team/amcharts/pen/zyvQjd?editors=0010   


    constructor(divElement: unknown) {
        super(divElement)
        this.amChart = am4core.create(this._am4ChartElement, am4charts.XYChart);
        this.requestVM = new CategoryChartRequestVM();
        this.indicatorLabel = this.amChart.createChild(am4core.Label);
    }

    addData(data: DataSet) {
        this.amChart.data = data.data;
        this.amChart.validateData();
    }

    addCategoryAxis(categoryX: string, inversed: boolean) {
        var categoryAxis: am4charts.CategoryAxis;
        if (inversed) {
            categoryAxis = this.amChart.yAxes.push(new am4charts.CategoryAxis());

        } else {
            categoryAxis = this.amChart.xAxes.push(new am4charts.CategoryAxis());
        }
        categoryAxis.dataFields.category = categoryX;
        categoryAxis.renderer.inversed = inversed;

    }

    addValueAxis(opposite: boolean) {
        if (opposite) {
            let valueAxis = this.amChart.xAxes.push(new am4charts.ValueAxis());
            valueAxis.renderer.opposite = opposite;
        }
        else {
            let valueAxis = this.amChart.yAxes.push(new am4charts.ValueAxis());
        }

    }

    addSeries(categoryX: string, valueY: string, isHorizontal: boolean) {
        let series = this.amChart.series.push(new am4charts.ColumnSeries());
        if (isHorizontal) {
            series.dataFields.valueX = valueY;
            series.dataFields.categoryY = categoryX;
        } else {

            series.dataFields.valueY = valueY;
            series.dataFields.categoryX = categoryX;
        }

    }

    success(data: object): void {
        let vm = new CategoryChartReportVM();
        vm.parseJson(data);
        if (vm.data.data.length === 0) {
            this.showChart(false);
        } else {
            this.showChart(true);
        }
        if (!this.isInitialized) {
            for (let categoryAxis of vm.categoryAxes) {
                this.addCategoryAxis(categoryAxis, vm.IsHorizontalChart);
            }
            this.addValueAxis(vm.IsHorizontalChart);
            for (let serie of vm.series) {
                this.addSeries(serie[0], serie[1], vm.IsHorizontalChart);
            }

            this.isInitialized = true;
        }

        this.addData(vm.data);
        this.ondataValidatedFunction(vm.IsHorizontalChart);

    }
    error(error: object): void {
        console.log(error);
    }

    filterCategory(searchString: string) {
        this.requestVM.addSingleEntityFilter(searchString);
    }


    ondataValidatedFunction(isHorizontal: boolean) {
        //taken from: https://www.amcharts.com/docs/v4/tutorials/auto-adjusting-chart-height-based-on-a-number-of-data-items/
        // Get objects of interest

        //only set height in case of a horizontal category chart
        if (!isHorizontal)
            return;

        let cellSize: number = 80;//in px
        let chart = this.amChart;
        let categoryAxis = chart.yAxes.getIndex(0);

        if (categoryAxis !== undefined) {
            // Calculate how we need to adjust chart height
            let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight;

            // get current chart height
            let targetHeight = chart.pixelHeight + adjustHeight;

            if (chart.svgContainer !== undefined)
                // Set it on chart's container
                chart.svgContainer.htmlElement.style.height = targetHeight + "px";
        }

    }
}

export class PieChart extends AmChartWrapper {
    public amChart: am4charts.PieChart;
    private isInitialized: boolean = false;

    constructor(divElement: unknown) {
        super(divElement)
        this.amChart = am4core.create(this._am4ChartElement, am4charts.PieChart);
        this.indicatorLabel = this.amChart.createChild(am4core.Label);
        this.requestVM = new PieChartRequestVM();

    }

    addData(data: DataSet) {
        console.log(data);
        this.amChart.data = data.data;

        this.amChart.validateData();
    }

    success(data: object): void {
        let vm = new PieChartReportVM();
        vm.parseJson(data);
        if (vm.data.data.length === 0) {
            this.showChart(false);
        } else {
            this.showChart(true);
        }

        console.log(vm);

        if (!this.isInitialized) {

            let pieSeries = this.amChart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = vm.value;
            pieSeries.dataFields.category = vm.category;
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;
            pieSeries.alignLabels = false;
            pieSeries.labels.template.bent = true;
            pieSeries.labels.template.radius = 3;
            pieSeries.labels.template.padding(0, 0, 0, 0);
            pieSeries.ticks.template.disabled = true;
            this.isInitialized = true;
        }

        this.addData(vm.data);
    }
    error(error: object): void {
        console.log(error);
    }
}


export class CategoryChart3D extends CategoryChart {

    addSeries(categoryX: string, valueY: string, isHorizontal: boolean) {
        let series = this.amChart.series.push(new am4charts.ColumnSeries3D());
        if (isHorizontal) {
            series.dataFields.valueX = valueY;
            series.dataFields.categoryY = categoryX;
        } else {

            series.dataFields.valueY = valueY;
            series.dataFields.categoryX = categoryX;
        }

    }
}

export class XYChart extends AmChartWrapper {

    public amChart: am4charts.XYChart;
    protected isInitialized: boolean = false;
    //private indicatorLabel: am4core.Label; // see https://codepen.io/team/amcharts/pen/zyvQjd?editors=0010   


    constructor(divElement: unknown) {
        super(divElement)
        this.amChart = am4core.create(this._am4ChartElement, am4charts.XYChart);
        this.requestVM = new XYChartRequestVM();
        this.indicatorLabel = this.amChart.createChild(am4core.Label);
    }

    addData(data: DataSet) {
        console.log("data=" + data);
        this.amChart.data = data.data;
        this.amChart.validateData();
    }

    addXAxis(categoryX: string, inversed: boolean) {
        var categoryAxis = this.amChart.xAxes.push(new am4charts.DateAxis());
        //categoryAxis.dataFields.date = categoryX;
        //categoryAxis.renderer.inversed = inversed;
    }

    addValueAxis(opposite: boolean) {
        let valueAxis = this.amChart.yAxes.push(new am4charts.ValueAxis());
        if (this.config !== undefined) {
            valueAxis.min = this.config.vAxisMin;
            valueAxis.max = this.config.vAxisMax;
            valueAxis.strictMinMax = this.config.strictMinMax;
        }

        this.amChart.cursor = new am4charts.XYCursor();
        //this.amChart.cursor.snapToSeries = series;
        this.amChart.cursor.xAxis = valueAxis;

    }

    addSeries(categoryX: string, valueY: string, isHorizontal: boolean, toolTipText?: string) {
        let series = this.amChart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = valueY;
        series.dataFields.dateX = categoryX;
        if (toolTipText === undefined)
            series.tooltipText = "{categoryX} {value}";
        else
            series.tooltipText = toolTipText;
        if (series.tooltip != undefined) series.tooltip.pointerOrientation = "horizontal";
    }

    success(data: object): void {
        let vm = new XYChartReportVM();
        vm.parseJson(data);
        if (vm.data.data.length === 0) {
            this.showChart(false);
        } else {
            this.showChart(true);
        }
        if (!this.isInitialized) {
            this.addXAxis(vm.category, vm.IsHorizontalChart);
            this.addValueAxis(vm.IsHorizontalChart);
            this.addSeries(vm.category, vm.value,true);
            this.isInitialized = true;
        }

        this.addData(vm.data);
        //this.ondataValidatedFunction(vm.IsHorizontalChart);

    }
    error(error: object): void {
        console.log(error);
    }

    filterCategory(searchString: string) {
        this.requestVM.addSingleEntityFilter(searchString);
    }


    ondataValidatedFunction(isHorizontal: boolean) {
        //taken from: https://www.amcharts.com/docs/v4/tutorials/auto-adjusting-chart-height-based-on-a-number-of-data-items/
        // Get objects of interest

        //only set height in case of a horizontal category chart
        if (!isHorizontal)
            return;

        let cellSize: number = 80;//in px
        let chart = this.amChart;
        let categoryAxis = chart.yAxes.getIndex(0);

        if (categoryAxis !== undefined) {
            // Calculate how we need to adjust chart height
            let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight;

            // get current chart height
            let targetHeight = chart.pixelHeight + adjustHeight;

            if (chart.svgContainer !== undefined)
                // Set it on chart's container
                chart.svgContainer.htmlElement.style.height = targetHeight + "px";
        }

    }
}